import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { IconButton, Menu, MenuItem } from '@mui/material';
import React, { useState } from 'react';
import ResponsiveButton from '../../uikit/buttons/ResponsiveButton';
import ConfirmationModal from '../ConfirmationModal';
import { useArchiveNote } from '../../services/react-query/notes/useArchiveNote';
import _ from 'lodash';
import { Note } from '../../types/Note';
import { queryClient } from '../../services/react-query/queryClient';
import { queryKeys } from '../../services/react-query/queryKeys';

interface NoteMoreOptionsPopoverProps {
  onEdit: (e: React.MouseEvent<HTMLButtonElement>) => void;
  note: Note;
}

const NoteMoreOptionsPopover: React.FC<NoteMoreOptionsPopoverProps> = ({ onEdit, note }) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [isArchiveConfirmOpen, setIsArchiveConfirmOpen] = useState(false);
  const open = Boolean(anchorEl);

  const { mutate: archiveNote } = useArchiveNote({
    uuid: _.toString(note.uuid),
    onSuccessCallback: () => {
      queryClient.invalidateQueries({
        queryKey: [
          queryKeys.allNotes,
          {
            filters: {
              noteable_uuid: note.noteable_uuid,
              noteable_type: note.noteable_type,
            },
          },
        ],
      });
    },
  });

  const handleOpen = (e: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(e.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleEdit = (e: React.MouseEvent<HTMLButtonElement>) => {
    onEdit(e);
    handleClose();
  };

  const handleArchiveClick = () => {
    setAnchorEl(null);
    setIsArchiveConfirmOpen(true);
  };

  const handleConfirmArchive = () => {
    setIsArchiveConfirmOpen(false);
    archiveNote();
  };

  return (
    <>
      <IconButton color="primary" onClick={handleOpen}>
        <MoreVertIcon />
      </IconButton>

      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <MenuItem>
          <ResponsiveButton onClick={handleEdit} startIcon={<EditIcon />}>
            Edit
          </ResponsiveButton>
        </MenuItem>
        <MenuItem>
          <ResponsiveButton onClick={handleArchiveClick} startIcon={<DeleteIcon />} sx={{ color: 'red' }}>
            Delete
          </ResponsiveButton>
        </MenuItem>
      </Menu>

      <ConfirmationModal
        isOpen={isArchiveConfirmOpen}
        onCancel={() => setIsArchiveConfirmOpen(false)}
        onConfirm={handleConfirmArchive}
        text="Are you sure you want to delete this note? This operation is irreversible!"
      />
    </>
  );
};

export default NoteMoreOptionsPopover;
